
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54 30.01v3.49a7.96 7.96 0 01-7.42 7.97c-.4 6.36-3.5 9.51-6.13 11.06a13.6 13.6 0 01-4.9 1.7 5.1 5.1 0 01-4.9 3.77h-3.63a5.12 5.12 0 01-5.08-5.14 5.11 5.11 0 015.08-5.13h3.62a5.1 5.1 0 014.83 3.54c2.41-.4 7.61-2.16 8.2-9.8h-2.02c-.8 0-1.45-.65-1.45-1.45V23.49c0-.8.65-1.46 1.45-1.46h2.07v-2.2c0-9.64-6.79-16.9-15.81-16.9h-1.82c-9.01 0-15.81 7.26-15.81 16.9v2.2h2.07c.8 0 1.45.66 1.45 1.46v16.54c0 .8-.65 1.46-1.45 1.46H7.9A7.95 7.95 0 010 33.51v-3.49a7.97 7.97 0 017.38-7.97v-2.23c0-5.33 1.87-10.3 5.26-13.97A18.05 18.05 0 0126.1 0h1.82c5.21 0 9.99 2.07 13.46 5.85a20.49 20.49 0 015.26 13.97v2.23A7.93 7.93 0 0154 30.01zm-43.07-5.06h-3c-2.77 0-5.01 2.27-5.01 5.06v3.49a5.03 5.03 0 005 5.05h3zm21.9 27.92a2.2 2.2 0 00-2.18-2.2h-3.63a2.2 2.2 0 00-2.19 2.2c0 1.22.98 2.2 2.19 2.2h3.63a2.2 2.2 0 002.18-2.2zm18.29-22.86a5.03 5.03 0 00-5-5.06h-3.01v13.6h3c2.76 0 5-2.26 5-5.05z"}})])
          )
        }
      }
    